import Router from './components/Router';

export * from './paths';
export * from './routes';
export default Router;
